(function () {
  document.addEventListener("variant:change", function (event) {
    const variant = event.detail.variant;

    const atcForm = document.querySelector(".product-block--atc form");
    if (!atcForm) return;

    const atcBtn = atcForm.querySelector('button[type="submit"][data-add-to-cart]');
    if (!atcBtn) return;

    if (!variant || !variant.available) {
      atcBtn.disabled = true;
      atcBtn.classList.add("disabled");
    } else {
      atcBtn.disabled = false;
      atcBtn.classList.remove("disabled");
    }
  });

  // Tabs
  const tabItems = document.querySelectorAll(".tab-nav__item");
  const tabBoxes = document.querySelectorAll(".tab-content__box");
  if (tabItems.length && tabBoxes.length) {
    tabItems.forEach((item) => {
      item.addEventListener("click", () => {
        const allItems = document.querySelectorAll('[data-parent="' + item.dataset.parent + '"]');
        if (allItems.length) {
          allItems.forEach((item) => {
            item.classList.remove("active");
          });
        }
        item.classList.add("active");

        const allTargets = document.querySelectorAll(
          '[data-section="' + item.dataset.parent + '"] .tab-content__box',
        );
        if (allTargets.length) {
          allTargets.forEach((target) => {
            target.classList.remove("active");
          });
        }

        const target = document.querySelector(
          '[data-section="' + item.dataset.parent + '"] #' + item.dataset.target,
        );
        if (target) {
          target.classList.add("active");
        }
      });
    });
  }

  // Popup slider
  const triggersOpen = document.querySelectorAll("[popup-trigger]");
  if (triggersOpen.length) {
    triggersOpen.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const modal = document.querySelector(trigger.getAttribute("popup-trigger"));
        if (modal) {
          modal.classList.add("open");
          const slider = document.querySelector(".mt-popup__carousel");
          if (slider) {
            const flkty = new Flickity(slider, {
              prevNextButtons: false,
            });
            if (trigger.dataset.index != null && flkty) {
              flkty.selectCell(parseInt(trigger.dataset.index));
            }
          }
        }
      });
    });
  }
  const triggersClose = document.querySelectorAll("[popup-close]");
  if (triggersClose.length) {
    triggersClose.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const modal = document.querySelector(trigger.getAttribute("popup-close"));
        if (modal) {
          modal.classList.remove("open");
        }
      });
    });
  }

  // Collections slider
  const slider = document.querySelector(".collections__carousel");
  if (slider) {
    const flkty = new Flickity(slider, {
      cellAlign: "left",
      contain: true,
      percentPosition: false,
      pageDots: false,
      arrowShape:
        "m27.3 69.2c0.8-0.9 0.6-2.3-0.3-3l-18.7-14.7h89.5c1.2 0 2.2-1 2.2-2.2 0-1.2-1-2.1-2.2-2.1h-89.4l18.5-14.4c1-0.7 1.2-2 0.4-3-0.7-0.9-2-1.1-3-0.3l-23.5 18.1c0 0 0 0.1-0.1 0.1q-0.2 0.2-0.4 0.4c0 0 0 0.1 0 0.1 0 0 0 0.1 0 0.1q-0.3 0.4-0.3 0.9c0 0 0 0 0 0v0.1c0 0 0 0.1 0 0.1q0 0.5 0.2 0.9c0 0 0 0.1 0 0.1l0.1 0.1q0.2 0.3 0.5 0.5l23.5 18.6q0.6 0.4 1.4 0.4c0.6 0 1.2-0.3 1.7-0.8z",
    });

    window.addEventListener("resize", () => {
      flkty.resize();
    });
  }

  // Cart Drawer Language Fix
  const currentLang = document.documentElement.getAttribute("lang");
  const languages = {
    fr: {
      warenkorb: "Panier",
      versand: "Livraison",
      berechnungImCheckout: "Calcul dans le checkout",
      zwischenzusammen: "Somme",
      zurKasse: "Procéder au paiement",
      deinWarenkorbIstLeer: "Votre panier est vide",
    },
  };
  function cartDrawerFix() {
    if (languages[currentLang]) {
      const warenkorb = document.querySelector("#slidecarthq .header h2");
      if (warenkorb && languages[currentLang].warenkorb) {
        warenkorb.innerHTML = warenkorb.innerHTML.replace(
          "Warenkorb",
          languages[currentLang].warenkorb,
        );
      }
      const versand = document.querySelector(
        "#slidecarthq .footer > .footer-row:first-child > .flex",
      );
      if (versand && languages[currentLang].versand) {
        versand.innerHTML = versand.innerHTML.replace("Versand", languages[currentLang].versand);
      }
      const berechnungImCheckout = document.querySelector(
        "#slidecarthq .footer .shipping-cost > span",
      );
      if (berechnungImCheckout && languages[currentLang].berechnungImCheckout) {
        berechnungImCheckout.innerHTML = berechnungImCheckout.innerHTML.replace(
          "Berechnung im Checkout",
          languages[currentLang].berechnungImCheckout,
        );
      }
      const zwischenzusammen = document.querySelector(
        "#slidecarthq .footer > .footer-row:nth-child(2) > .flex",
      );
      if (zwischenzusammen && languages[currentLang].zwischenzusammen) {
        zwischenzusammen.innerHTML = zwischenzusammen.innerHTML.replace(
          "Zwischenzusammen",
          languages[currentLang].zwischenzusammen,
        );
      }
      const zurKasse = document.querySelector("#slidecarthq #slidecart-checkout-form .button");
      if (zurKasse && languages[currentLang].zurKasse) {
        zurKasse.innerHTML = zurKasse.innerHTML.replace(
          "Zur Kasse",
          languages[currentLang].zurKasse,
        );
      }
      const deinWarenkorbIstLeer = document.querySelector("#slidecarthq .empty p");
      if (deinWarenkorbIstLeer && languages[currentLang].deinWarenkorbIstLeer) {
        deinWarenkorbIstLeer.innerHTML = deinWarenkorbIstLeer.innerHTML.replace(
          "Dein Warenkorb ist leer",
          languages[currentLang].deinWarenkorbIstLeer,
        );
      }
    }
  }
  const cartBtn = document.querySelectorAll('[aria-controls="CartDrawer"]');
  if (cartBtn.length) {
    cartBtn.forEach((btn) => {
      btn.addEventListener("click", cartDrawerFix);
    });
  }
  const addToCartBtns = document.querySelectorAll("[data-add-to-cart]");
  if (addToCartBtns.length) {
    addToCartBtns.forEach((btn) => {
      btn.addEventListener("click", cartDrawerFix);
    });
  }

  if (!Shopify.designMode) {
    const v3ModalRelocate = document.querySelectorAll(".modal--v3");
    if (v3ModalRelocate.length) {
      v3ModalRelocate.forEach((modal) => {
        document.body.appendChild(modal);
      });
    }
  }

  const modalTriggers = document.querySelectorAll("[open-modal]");
  if (modalTriggers.length) {
    modalTriggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        const target = document.querySelector(trigger.getAttribute("href"));
        if (target) {
          target.classList.add("modal--is-active");
        }
      });
    });
  }

  const modalCloseTriggers = document.querySelectorAll("[close-modal]");
  if (modalCloseTriggers.length) {
    modalCloseTriggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        const target = document.querySelector(trigger.getAttribute("data-close"));
        if (target) {
          target.classList.remove("modal--is-active");
        }
      });
    });
  }

  setTimeout(() => {
    const reviewsCounter = document.querySelectorAll(".ruk-rating-snippet-count");
    if (reviewsCounter.length) {
      reviewsCounter.forEach((counter) => {
        counter.dataset.short = counter.innerHTML.split(" ")[0] + ")";
        counter.dataset.long = counter.innerHTML;
      });
    }

    function setReviewsText() {
      const reviewsCounter = document.querySelectorAll(".ruk-rating-snippet-count");
      if (reviewsCounter.length) {
        reviewsCounter.forEach((counter) => {
          if (window.innerWidth < 768) {
            counter.innerHTML = counter.dataset.short;
          } else {
            counter.innerHTML = counter.dataset.long;
          }
        });
      }
    }

    setReviewsText();
    window.addEventListener("resize", setReviewsText);
  }, 1000);

  // --- Megamenu two-column interactivity ---
  document.addEventListener("DOMContentLoaded", () => {
    const initMegaMenus = () => {
      const megaMenus = document.querySelectorAll(".site-nav--is-megamenu");
      if (!megaMenus.length) return;
      megaMenus.forEach((megaMenu) => {
        const parentTitles = megaMenu.querySelectorAll(".megamenu__parent-title");
        const subcatGrids = megaMenu.querySelectorAll(".megamenu__subcat-grid");
        const gridsWrapper = megaMenu.querySelector(".megamenu__subcat-grids-wrapper");
        const details = megaMenu.closest("details");
        if (!parentTitles.length || !subcatGrids.length || !gridsWrapper) return;
        // Ensure first panel is active on initial load
        if (
          parentTitles.length > 0 &&
          !megaMenu.querySelector(".megamenu__parent-title.is-active")
        ) {
          parentTitles[0].classList.add("is-active");
        }
        if (subcatGrids.length > 0 && !megaMenu.querySelector(".megamenu__subcat-grid.is-active")) {
          subcatGrids[0].classList.add("is-active");
        }
        // Set initial height
        const setWrapperHeight = () => {
          if (details && !details.open) {
            gridsWrapper.style.height = "0px";
          } else {
            const activeGrid = gridsWrapper.querySelector(".megamenu__subcat-grid.is-active");
            if (activeGrid) {
              gridsWrapper.style.height = activeGrid.offsetHeight + "px";
            }
          }
        };
        setTimeout(setWrapperHeight, 0);
        // Animate height on panel switch
        const activatePanel = (titleEl) => {
          parentTitles.forEach((t) => t.classList.remove("is-active"));
          subcatGrids.forEach((g) => g.classList.remove("is-active"));
          titleEl.classList.add("is-active");
          const panelIdx = titleEl.getAttribute("data-parent-index");
          const grid = megaMenu.querySelector(
            `.megamenu__subcat-grid[data-panel-index="${panelIdx}"]`,
          );
          if (grid) grid.classList.add("is-active");
          setTimeout(setWrapperHeight, 0);
        };
        parentTitles.forEach((title) => {
          title.addEventListener("mouseenter", () => activatePanel(title));
          title.addEventListener("focus", () => activatePanel(title));
          title.addEventListener("click", (e) => {
            e.preventDefault();
            activatePanel(title);
          });
        });
        // On window resize, recalc height
        window.addEventListener("resize", setWrapperHeight);
        // Animate on open/close
        if (details) {
          details.addEventListener("toggle", setWrapperHeight);
        }
      });
    };
    // Initialize on load
    initMegaMenus();
    // Re-initialize when Shopify section refreshes
    document.addEventListener("shopify:section:load", initMegaMenus);
  });

  // Gallery Filter System - Fixed Version
  document.addEventListener("DOMContentLoaded", () => {
    // PhotoSwipe is handled by theme.js, no custom cleanup needed

    // Get variants and dropdown
    const variants =
      window.productVariants ||
      JSON.parse(document.querySelector("[data-variant-json]")?.textContent || "[]");
    const flavourDropdown = document.querySelector("[data-flavour-dropdown]");
    const subvariantButtonsContainer = document.querySelector("[data-subvariant-buttons]");

    if (!flavourDropdown || !subvariantButtonsContainer) {
      return;
    }

    // Gallery Management Class
    class FilteredGallery {
      constructor(galleryElement) {
        this.gallery = galleryElement;
        this.slideshow = galleryElement.querySelector("[data-product-photos]");
        this.thumbsContainer = galleryElement.querySelector(".product__thumbs");
        this.thumbsScroller = this.thumbsContainer?.querySelector(".product__thumbs--scroller");

        this.mainFlickity = null;
        this.thumbsFlickity = null;
        this.currentFlavour = null;
        this.isInitialized = false;

        // Store original content
        this.originalSlides = [];
        this.originalThumbs = [];
        this.originalBadgesHTML = null;

        this.init();
      }

      init() {
        if (!this.slideshow || !this.thumbsScroller) {
          return;
        }

        // Store original slides and thumbs with their data attributes
        this.storeOriginalContent();

        // Initialize Flickity first time with all content
        this.initializeFlickity();

        // Setup zoom button hover effects for initial content
        this.setupZoomButtonHover();

        // PhotoSwipe is handled by theme.js in initImageZoom()

        // Listen for PhotoSwipe afterChange events to sync with main slider
        this.setupPhotoSwipeListener();

        // Then filter if there's an initial flavour
        const initialFlavour = flavourDropdown.value;
        if (initialFlavour) {
          // Use setTimeout to ensure Flickity is fully initialized
          setTimeout(() => {
            this.updateGallery(initialFlavour);
          }, 100);
        }

        this.isInitialized = true;
      }

      storeOriginalContent() {
        // Store slides with their data attributes
        const slides = this.slideshow.querySelectorAll(".product-main-slide");

        // Extract badge HTML from the first slide if it exists
        const firstSlide = slides[0];
        if (firstSlide) {
          const badgesContainer = firstSlide.querySelector("[data-pdp-badges]");
          if (badgesContainer) {
            this.originalBadgesHTML = badgesContainer.outerHTML;
          }
        }

        slides.forEach((slide) => {
          // Skip empty slides (those without product-image-main)
          if (!slide.querySelector(".product-image-main")) {
            return;
          }

          const img = slide.querySelector("img");
          const altText = img?.alt?.toLowerCase() || "";
          const slideIndex = parseInt(slide.getAttribute("data-index"), 10);

          // Clone slide and remove badges from the clone (we'll add them back to first slide after filtering)
          const clonedSlide = slide.cloneNode(true);
          const badgesInClone = clonedSlide.querySelector("[data-pdp-badges]");
          if (badgesInClone) {
            badgesInClone.remove();
          }

          this.originalSlides.push({
            element: clonedSlide,
            flavour: slide.getAttribute("data-flavor")?.toLowerCase() || altText,
            index: !isNaN(slideIndex) ? slideIndex : 0,
          });
        });

        // Store thumbs with their data attributes
        const thumbs = this.thumbsScroller.querySelectorAll(".product__thumb-item");
        thumbs.forEach((thumb) => {
          // Skip empty thumbs (those without img)
          if (!thumb.querySelector("img")) {
            return;
          }

          const img = thumb.querySelector("img");
          const altText = img?.alt?.toLowerCase() || "";
          const thumbIndex = parseInt(thumb.getAttribute("data-index"), 10);

          this.originalThumbs.push({
            element: thumb.cloneNode(true),
            flavour: thumb.getAttribute("data-flavor")?.toLowerCase() || altText,
            index: !isNaN(thumbIndex) ? thumbIndex : 0,
          });
        });
      }

      initializeFlickity() {
        // Don't initialize if already done
        if (this.mainFlickity || this.thumbsFlickity) {
          return;
        }

        // Ensure slideshow container is visible and has proper styling
        if (this.slideshow) {
          this.slideshow.style.display = "block";
          this.slideshow.style.opacity = "1";
          this.slideshow.style.visibility = "visible";
        }

        // Initialize main slideshow
        if (this.slideshow && this.slideshow.children.length > 0) {
          // Ensure all slides are visible before initialization
          const slides = this.slideshow.querySelectorAll(".product-main-slide");
          slides.forEach((slide) => {
            slide.style.display = "block";
            slide.style.opacity = "1";
            slide.style.visibility = "visible";
          });

          this.mainFlickity = new Flickity(this.slideshow, {
            wrapAround: false,
            adaptiveHeight: true,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            contain: false,
          });

          // Add additional ready event listener for extra safety
          this.mainFlickity.on("ready", () => {
            this.ensureSlideVisibility();
            this.mainFlickity.resize();
          });

          // Add change event to sync active thumbnail
          this.mainFlickity.on("change", (index) => {
            // Remove is-active from all thumbs
            this.thumbsScroller.querySelectorAll(".product__thumb").forEach((thumb) => {
              thumb.classList.remove("is-active");
            });
            // Add is-active to the thumb corresponding to the current slide
            const activeThumb = this.thumbsScroller.querySelector(
              `.product__thumb-item[data-index="${index}"] .product__thumb`,
            );
            if (activeThumb) {
              activeThumb.classList.add("is-active");
            }
            // Slide the thumbnail Flickity slider to the corresponding thumb with smooth animation
            if (this.thumbsFlickity) {
              this.thumbsFlickity.select(index, false, false); // isWrapped=false, isInstant=false for smooth scroll
            }
          });
        }

        // Initialize thumbnails if there are any
        if (this.thumbsScroller && this.thumbsScroller.children.length > 0) {
          this.thumbsFlickity = new Flickity(this.thumbsScroller, {
            wrapAround: false,
            adaptiveHeight: false,
            prevNextButtons: false,
            pageDots: false,
            asNavFor: this.slideshow,
            draggable: true,
            contain: true,
          });

          // Add ready event listener
          this.thumbsFlickity.on("ready", () => {
            this.setupThumbnailClickHandlers();
          });
        }
      }

      initializePhotoSwipe() {
        // Don't initialize PhotoSwipe here - let the theme handle it
        // The theme.js already initializes PhotoSwipe in initImageZoom()
      }

      // Add method to re-initialize PhotoSwipe after content updates
      reinitializePhotoSwipe() {
        // Find the product container
        const productContainer = this.slideshow.closest('[data-section-type="product"]');
        if (!productContainer) {
          return;
        }

        // Find the image container
        const imageContainer = productContainer.querySelector("[data-product-images]");
        if (!imageContainer) {
          return;
        }

        // Get the section ID
        const sectionId = productContainer.getAttribute("data-section-id");
        if (!sectionId) {
          return;
        }

        // Clean up existing PhotoSwipe instance if it exists
        this.cleanupExistingPhotoSwipe(imageContainer, sectionId);

        // Re-initialize PhotoSwipe
        try {
          // Check if PhotoSwipe library is loaded
          if (typeof PhotoSwipe === "undefined" || typeof PhotoSwipeUI_Default === "undefined") {
            return;
          }

          const imageZoom = new theme.Photoswipe(imageContainer, sectionId);
        } catch (error) {
          // Silent error handling for production
        }
      }

      cleanupExistingPhotoSwipe(imageContainer, sectionId) {
        // Find existing PhotoSwipe instance and destroy it
        const productContainer = imageContainer.closest('[data-section-type="product"]');
        if (
          productContainer &&
          productContainer.imageZoom &&
          typeof productContainer.imageZoom.destroy === "function"
        ) {
          productContainer.imageZoom.destroy();
          productContainer.imageZoom = null;
        }

        // Remove existing event listeners from zoom buttons
        const existingZoomButtons = imageContainer.querySelectorAll(".js-photoswipe__zoom");
        const namespace = ".photoswipe-" + sectionId;

        existingZoomButtons.forEach((button) => {
          // Remove all click event listeners
          button.removeEventListener("click" + namespace, null);

          // Also try to remove any generic click listeners
          const newButton = button.cloneNode(true);
          button.parentNode.replaceChild(newButton, button);
        });

        // Close any open PhotoSwipe gallery
        const pswpElement = document.querySelector(".pswp");
        if (pswpElement && pswpElement.classList.contains("pswp--open")) {
          // Trigger close event
          const closeEvent = new Event("close");
          pswpElement.dispatchEvent(closeEvent);

          // Force close by removing open class
          pswpElement.classList.remove("pswp--open");
          pswpElement.classList.remove("pswp--visible");
        }
      }

      // Add new method to handle active thumbnail highlighting
      highlightActiveThumbnail(slideIndex) {
        // Remove active class from all thumbnails
        const allThumbs = this.thumbsScroller.querySelectorAll(".product__thumb-item");
        allThumbs.forEach((thumb) => {
          thumb.classList.remove("is-active-thumb");
        });

        // Add active class to the corresponding thumbnail
        const activeThumb = this.thumbsScroller.querySelector(
          `.product__thumb-item[data-index="${slideIndex}"]`,
        );
        if (activeThumb) {
          activeThumb.classList.add("is-active-thumb");
        }
      }

      handleThumbnailClick(event) {
        // Prevent both default and propagation to stop any navigation
        event.preventDefault();
        event.stopPropagation();

        const thumb = event.currentTarget;
        const thumbItem = thumb.closest(".product__thumb-item");
        const index = parseInt(thumbItem.getAttribute("data-index"), 10);

        if (!isNaN(index) && this.mainFlickity) {
          // Find the corresponding slide by matching data-index
          const slides = this.slideshow.querySelectorAll(".product-main-slide");
          let targetSlideIndex = -1;

          slides.forEach((slide, i) => {
            const slideIndex = parseInt(slide.getAttribute("data-index"), 10);
            if (slideIndex === index) {
              targetSlideIndex = i;
            }
          });

          if (targetSlideIndex !== -1) {
            this.mainFlickity.select(index, false, false);
            this.ensureSlideVisibility();
            // Highlight the clicked thumbnail
            this.highlightActiveThumbnail(index);
          }
        }

        // Remove is-active from all thumbs
        this.thumbsScroller.querySelectorAll(".product__thumb").forEach((thumbEl) => {
          thumbEl.classList.remove("is-active");
        });
        // Add is-active to the clicked thumb
        thumb.classList.add("is-active");

        // Return false to prevent any default behavior
        return false;
      }

      // Add new method to setup zoom button hover effects
      setupZoomButtonHover() {
        const mainSlides = this.slideshow.querySelectorAll(".product-main-slide");

        mainSlides.forEach((slide) => {
          const zoomButton = slide.querySelector(".js-photoswipe__zoom");
          if (!zoomButton) return;

          // Add hover event listeners to the slide
          slide.addEventListener("mouseenter", () => {
            zoomButton.style.display = "flex";
          });

          slide.addEventListener("mouseleave", () => {
            zoomButton.style.display = "";
          });
        });
      }

      setupThumbnailClickHandlers() {
        const thumbLinks = this.thumbsScroller.querySelectorAll(".product__thumb");
        thumbLinks.forEach((link) => {
          // Remove any existing click handlers
          link.removeEventListener("click", this.handleThumbnailClick);

          // Remove href attribute to prevent navigation
          link.removeAttribute("href");

          // Add new click handler with both capture and bubble phase
          link.addEventListener("click", this.handleThumbnailClick.bind(this), true);
          link.addEventListener("click", this.handleThumbnailClick.bind(this), false);
        });
      }

      // Add new helper method to ensure slide visibility
      ensureSlideVisibility() {
        if (!this.slideshow) return;

        // Ensure container is visible
        this.slideshow.style.display = "block";
        this.slideshow.style.opacity = "1";
        this.slideshow.style.visibility = "visible";

        // Ensure all slides are visible
        const slides = this.slideshow.querySelectorAll(".product-main-slide");
        slides.forEach((slide) => {
          slide.style.display = "block";
          slide.style.opacity = "1";
          slide.style.visibility = "visible";
        });

        // Force resize if Flickity exists
        if (this.mainFlickity) {
          this.mainFlickity.resize();
        }
      }

      cleanupFlickity() {
        if (this.mainFlickity) {
          try {
            this.mainFlickity.destroy();
          } catch (e) {}
          this.mainFlickity = null;
        }
        if (this.thumbsFlickity) {
          try {
            this.thumbsFlickity.destroy();
          } catch (e) {}
          this.thumbsFlickity = null;
        }

        // PhotoSwipe is handled by theme.js, no cleanup needed here
      }

      async updateGallery(flavour) {
        if (!flavour) {
          return;
        }

        // Filter slides and thumbs using translated flavor values
        // All matching is based on custom.flavor_label metafield and translated values
        const flavorLower = flavour.toLowerCase();

        const filteredSlides = this.originalSlides.filter((slide) => {
          if (!slide.flavour) {
            return true; // Keep slides without flavor
          }

          const img = slide.element.querySelector("img");
          if (!img) {
            return false;
          }

          const altText = img.alt?.toLowerCase() || "";
          const slideFlavor = slide.flavour.toLowerCase();

          const matchesDataFlavor = slideFlavor === flavorLower;
          const matchesAltText = altText.includes(flavorLower);
          const matches = matchesDataFlavor || matchesAltText;

          // Match using translated flavor value (from data-flavor attribute)
          // Also check alt text as fallback
          return matches;
        });

        const filteredThumbs = this.originalThumbs.filter((thumb) => {
          if (!thumb.flavour) {
            return true; // Keep thumbs without flavor
          }

          const img = thumb.element.querySelector("img");
          if (!img) {
            return false;
          }

          const altText = img.alt?.toLowerCase() || "";
          const thumbFlavor = thumb.flavour.toLowerCase();

          const matchesDataFlavor = thumbFlavor === flavorLower;
          const matchesAltText = altText.includes(flavorLower);
          const matches = matchesDataFlavor || matchesAltText;

          // Match using translated flavor value (from data-flavor attribute)
          // Also check alt text as fallback
          return matches;
        });

        // Deduplicate: only keep the outermost .product-main-slide for each index
        const uniqueSlidesByIndex = [];
        const seenIndexes = new Set();
        for (const slide of filteredSlides) {
          // Only keep the outermost .product-main-slide for each index
          const isSecondary = slide.element.classList.contains("secondary-slide");
          const isNested =
            slide.element.closest(".product-main-slide") !== slide.element &&
            slide.element.closest(".product-main-slide");
          if (
            !seenIndexes.has(slide.index) &&
            !isSecondary &&
            !isNested &&
            slide.element.querySelector(".product-image-main")
          ) {
            uniqueSlidesByIndex.push(slide);
            seenIndexes.add(slide.index);
          }
        }
        // Use uniqueSlidesByIndex for the rest of the logic

        const slideIndexes = new Set(uniqueSlidesByIndex.map((s) => s.index));
        const thumbIndexes = new Set(filteredThumbs.map((t) => t.index));
        const sharedIndexes = [...slideIndexes].filter((i) => thumbIndexes.has(i));
        const filteredSlidesSynced = uniqueSlidesByIndex.filter((s) =>
          sharedIndexes.includes(s.index),
        );
        const filteredThumbsSynced = filteredThumbs.filter((t) => sharedIndexes.includes(t.index));

        // If no slides after filtering, show all content
        if (filteredSlidesSynced.length === 0) {
          await this.showAllContent();
          return;
        }

        // If we have existing Flickity instances, use their methods to update
        if (this.mainFlickity && this.thumbsFlickity) {
          await this.updateFlickityContent(filteredSlidesSynced, filteredThumbsSynced);
        } else {
          // Fallback: rebuild everything
          await this.rebuildGallery(filteredSlidesSynced, filteredThumbsSynced);
        }

        // After updating content, ensure proper thumbnail state
        await new Promise((resolve) => {
          requestAnimationFrame(() => {
            // Remove active class from all thumbnails
            this.thumbsScroller.querySelectorAll(".product__thumb").forEach((thumb) => {
              thumb.classList.remove("is-active");
            });

            // Get the current slide index
            const currentIndex = this.mainFlickity ? this.mainFlickity.selectedIndex : 0;

            // Add active class to the corresponding thumbnail
            const activeThumb = this.thumbsScroller.querySelector(
              `.product__thumb-item[data-index="${currentIndex}"] .product__thumb`,
            );
            if (activeThumb) {
              activeThumb.classList.add("is-active");
            }

            // Ensure thumbnail slider is at the correct position
            if (this.thumbsFlickity) {
              this.thumbsFlickity.select(currentIndex, false, true);
            }
            resolve();
          });
        });

        this.currentFlavour = flavour.toLowerCase();
      }

      async updateFlickityContent(filteredSlides, filteredThumbs) {
        try {
          // Remove all existing cells
          const existingSlides = this.slideshow.querySelectorAll(".product-main-slide");
          existingSlides.forEach((slide) => {
            this.mainFlickity.remove(slide);
          });

          const existingThumbs = this.thumbsScroller.querySelectorAll(".product__thumb-item");
          existingThumbs.forEach((thumb) => {
            this.thumbsFlickity.remove(thumb);
          });

          // Add filtered slides with visibility settings and sequential data-index
          filteredSlides.forEach((slide, i) => {
            // Skip empty slides
            if (!slide.element.querySelector(".product-image-main")) {
              return;
            }
            const newSlide = slide.element.cloneNode(true);
            // Set sequential data-index
            newSlide.setAttribute("data-index", i);
            newSlide.style.display = "block";
            newSlide.style.opacity = "1";
            newSlide.style.visibility = "visible";

            // Remove any existing badges (they'll be added back to first slide)
            const existingBadges = newSlide.querySelector("[data-pdp-badges]");
            if (existingBadges) {
              existingBadges.remove();
            }

            // Add badges to the first slide (index 0)
            if (i === 0 && this.originalBadgesHTML) {
              // Insert badges at the beginning of the slide
              const tempDiv = document.createElement("div");
              tempDiv.innerHTML = this.originalBadgesHTML;
              const badgesContainer = tempDiv.firstElementChild;
              newSlide.insertBefore(badgesContainer, newSlide.firstChild);
            }

            // Ensure zoom button has the correct data-index
            const zoomButton = newSlide.querySelector(".js-photoswipe__zoom");
            if (zoomButton) {
              zoomButton.setAttribute("data-index", i);
            }

            this.mainFlickity.append(newSlide);
          });

          // Add filtered thumbs with sequential data-index
          filteredThumbs.forEach((thumb, i) => {
            // Skip empty thumbs
            if (!thumb.element.querySelector("img")) {
              return;
            }
            const newThumb = thumb.element.cloneNode(true);
            // Set sequential data-index
            newThumb.setAttribute("data-index", i);
            // Add product__thumb-item class
            newThumb.classList.add("product__thumb-item");
            // Remove href from thumb links to prevent navigation
            const thumbLink = newThumb.querySelector(".product__thumb");
            if (thumbLink) {
              thumbLink.removeAttribute("href");
            }
            this.thumbsFlickity.append(newThumb);
          });

          // Force reflow and ensure visibility
          this.ensureSlideVisibility();

          // Always select the first slide after filtering
          await new Promise((resolve) => {
            requestAnimationFrame(() => {
              if (this.mainFlickity) {
                // Force select first slide and ensure it's visible
                this.mainFlickity.select(0, false, true);
                this.ensureSlideVisibility();

                // Additional check to ensure first slide is properly displayed
                const firstSlide = this.slideshow.querySelector(".product-main-slide");
                if (firstSlide) {
                  firstSlide.style.display = "block";
                  firstSlide.style.opacity = "1";
                  firstSlide.style.visibility = "visible";
                  firstSlide.classList.add("is-selected");
                }
              }
              if (this.thumbsFlickity) {
                this.thumbsFlickity.select(0, false, true);
              }
              resolve();
            });
          });

          // Re-setup thumbnail click handlers after content update
          this.setupThumbnailClickHandlers();

          // Setup zoom button hover effects
          this.setupZoomButtonHover();

          // Re-initialize PhotoSwipe after content update
          await new Promise((resolve) => {
            setTimeout(() => {
              this.reinitializePhotoSwipe();
              resolve();
            }, 150);
          });

          // Fix mobile thumbs height after content update
          await new Promise((resolve) => {
            setTimeout(() => {
              this.fixMobileThumbsHeight();
              resolve();
            }, 200);
          });
        } catch (e) {
          await this.rebuildGallery(filteredSlides, filteredThumbs);
        }
      }

      async rebuildGallery(filteredSlides, filteredThumbs) {
        // Clean up existing Flickity instances
        this.cleanupFlickity();

        // Clear existing content
        this.slideshow.innerHTML = "";
        this.thumbsScroller.innerHTML = "";

        // Add filtered content with visibility settings and sequential data-index
        filteredSlides.forEach((slide, i) => {
          // Skip empty slides
          if (!slide.element.querySelector(".product-image-main")) {
            return;
          }
          const newSlide = slide.element.cloneNode(true);
          newSlide.setAttribute("data-index", i);
          newSlide.style.display = "block";
          newSlide.style.opacity = "1";
          newSlide.style.visibility = "visible";

          // Remove any existing badges (they'll be added back to first slide)
          const existingBadges = newSlide.querySelector("[data-pdp-badges]");
          if (existingBadges) {
            existingBadges.remove();
          }

          // Add badges to the first slide (index 0)
          if (i === 0 && this.originalBadgesHTML) {
            // Insert badges at the beginning of the slide
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = this.originalBadgesHTML;
            const badgesContainer = tempDiv.firstElementChild;
            newSlide.insertBefore(badgesContainer, newSlide.firstChild);
          }

          // Ensure zoom button has the correct data-index
          const zoomButton = newSlide.querySelector(".js-photoswipe__zoom");
          if (zoomButton) {
            zoomButton.setAttribute("data-index", i);
          }

          this.slideshow.appendChild(newSlide);
        });
        filteredThumbs.forEach((thumb, i) => {
          // Skip empty thumbs
          if (!thumb.element.querySelector("img")) {
            return;
          }
          const newThumb = thumb.element.cloneNode(true);
          newThumb.setAttribute("data-index", i);
          // Add product__thumb-item class
          newThumb.classList.add("product__thumb-item");
          // Remove href from thumb links to prevent navigation
          const thumbLink = newThumb.querySelector(".product__thumb");
          if (thumbLink) {
            thumbLink.removeAttribute("href");
          }
          newThumb.style.display = "block";
          newThumb.style.opacity = "1";
          newThumb.style.visibility = "visible";
          this.thumbsScroller.appendChild(newThumb);
        });

        // Ensure containers are visible
        this.ensureSlideVisibility();

        // Reinitialize Flickity with requestAnimationFrame for smoother transitions
        await new Promise((resolve) => {
          requestAnimationFrame(() => {
            this.initializeFlickity();

            // Additional check after initialization to ensure first slide is selected and visible
            requestAnimationFrame(() => {
              this.ensureSlideVisibility();
              if (this.mainFlickity) {
                // Force select first slide
                this.mainFlickity.select(0, false, true);

                // Ensure first slide is properly displayed
                const firstSlide = this.slideshow.querySelector(".product-main-slide");
                if (firstSlide) {
                  firstSlide.style.display = "block";
                  firstSlide.style.opacity = "1";
                  firstSlide.style.visibility = "visible";
                  firstSlide.classList.add("is-selected");
                }
              }
              // Re-setup thumbnail click handlers after rebuild
              this.setupThumbnailClickHandlers();

              // Setup zoom button hover effects
              this.setupZoomButtonHover();

              // Re-initialize PhotoSwipe after rebuild
              setTimeout(() => {
                this.reinitializePhotoSwipe();
              }, 150);

              // Fix mobile thumbs height after rebuild
              setTimeout(() => {
                this.fixMobileThumbsHeight();
              }, 200);

              resolve();
            });
          });
        });

        // Remove is-active from all thumbs
        this.thumbsScroller.querySelectorAll(".product__thumb").forEach((thumb) => {
          thumb.classList.remove("is-active");
        });
        // Add is-active to the first thumb
        const firstThumb = this.thumbsScroller.querySelector(
          '.product__thumb-item[data-index="0"] .product__thumb',
        );
        if (firstThumb) {
          firstThumb.classList.add("is-active");
        }
      }

      async showAllContent() {
        if (this.mainFlickity && this.thumbsFlickity) {
          // Use update method if Flickity exists
          await this.updateFlickityContent(this.originalSlides, this.originalThumbs);
        } else {
          // Rebuild if no Flickity
          await this.rebuildGallery(this.originalSlides, this.originalThumbs);
        }

        // Additional visibility check
        await new Promise((resolve) => {
          setTimeout(() => {
            const firstSlide = this.slideshow.querySelector(".product-main-slide");
            if (firstSlide) {
              firstSlide.style.display = "block";
              firstSlide.style.opacity = "1";
            }

            // Setup zoom button hover effects
            this.setupZoomButtonHover();

            // Re-initialize PhotoSwipe after showing all content
            this.reinitializePhotoSwipe();

            // Fix mobile thumbs height after showing all content
            this.fixMobileThumbsHeight();
            resolve();
          }, 150);
        });
      }

      resize() {
        if (this.mainFlickity) {
          this.mainFlickity.resize();
        }
        if (this.thumbsFlickity) {
          this.thumbsFlickity.resize();
        }

        // Fix mobile thumbs container height
        this.fixMobileThumbsHeight();
      }

      fixMobileThumbsHeight() {
        if (!this.thumbsContainer) return;

        if (window.innerWidth <= 768) {
          this.thumbsContainer.style.height = "auto";

          this.thumbsContainer.offsetHeight;

          const thumbsContent = this.thumbsScroller.querySelector(".flickity-viewport");
          if (thumbsContent) {
            const contentHeight = thumbsContent.scrollHeight;
            if (contentHeight > 0) {
              this.thumbsContainer.style.height = contentHeight + "px";
            }
          }

          const thumbItems = this.thumbsScroller.querySelectorAll(".product__thumb-item");
          if (thumbItems.length > 0) {
            const firstThumb = thumbItems[0];
            const thumbHeight = firstThumb.offsetHeight;
            if (thumbHeight > 0) {
              this.thumbsContainer.style.height = thumbHeight + 20 + "px";
            }
          }
        }
      }

      findSlideByFlavor(flavor, variantValue) {
        if (!this.slideshow) return null;

        const slides = this.slideshow.querySelectorAll(".product-main-slide");
        for (const slide of slides) {
          const img = slide.querySelector("img");
          if (!img) continue;
          const altText = img.alt || "";
          // Check if the flavor matches the alt text pattern [flavor] - [something]
          if (altText.includes(flavor + " - " + variantValue)) {
            return slide;
          }
        }
        return null;
      }

      selectSlideByFlavor(flavor, variantValue) {
        const matchingSlide = this.findSlideByFlavor(flavor, variantValue);
        if (matchingSlide && this.mainFlickity) {
          const slideIndex = parseInt(matchingSlide.getAttribute("data-index"), 10);
          if (!isNaN(slideIndex)) {
            this.mainFlickity.select(slideIndex, false, false);
            this.ensureSlideVisibility();

            this.thumbsScroller.querySelectorAll(".product__thumb").forEach((thumb) => {
              thumb.classList.remove("is-active");
            });
            const activeThumb = this.thumbsScroller.querySelector(
              `.product__thumb-item[data-index="${slideIndex}"] .product__thumb`,
            );
            if (activeThumb) {
              activeThumb.classList.add("is-active");
            }
            if (this.thumbsFlickity) {
              this.thumbsFlickity.select(slideIndex, false, false);
            }
          }
        }
      }

      setupPhotoSwipeListener() {
        window.addEventListener("photoswipe:afterChange", (event) => {
          const photoSwipeIndex = event.detail.index;

          // Update the main slider to the corresponding index
          if (this.mainFlickity && !isNaN(photoSwipeIndex)) {
            this.mainFlickity.select(photoSwipeIndex, false, true);

            // Update active thumbnail
            this.highlightActiveThumbnail(photoSwipeIndex);

            // Ensure thumbnail slider is at the correct position
            if (this.thumbsFlickity) {
              this.thumbsFlickity.select(photoSwipeIndex, false, true);
            }
          }
        });
      }
    }

    const galleries = document.querySelectorAll("[data-product-images]");
    let activeGallery = null;

    for (const gallery of galleries) {
      if (gallery.offsetParent !== null) {
        activeGallery = new FilteredGallery(gallery);
        break;
      }
    }

    if (!activeGallery && galleries.length > 0) {
      activeGallery = new FilteredGallery(galleries[0]);
    }

    if (!activeGallery) {
      return;
    }

    function highlightActiveFlavour(flavour) {
      subvariantButtonsContainer.querySelectorAll(".variant-input").forEach((btn) => {
        const input = btn.querySelector("input");
        if (input?.dataset.variantFlavour === flavour) {
          btn.classList.add("is-active-flavour");
        } else {
          btn.classList.remove("is-active-flavour");
        }
      });

      const firstInput = document.querySelector(
        '[data-variant-input][data-variant-flavour="' +
          defaultFlavour +
          '"]:not(:disabled):not(.disabled)',
      );
      if (firstInput) {
        const variantId = firstInput.dataset.variantId;
        const variant = variants.find((v) => v.id === parseInt(variantId));
        updateVariantQtyDisplay(variant);
      }
    }

    function selectFirstSubvariantForFlavor(flavour) {
      const subvariantInputs = document.querySelectorAll(
        '[data-variant-input][data-variant-flavour="' +
          flavour +
          '"]:not(:disabled):not(.disabled)',
      );

      if (subvariantInputs.length > 0) {
        const firstInput = subvariantInputs[0];

        document.querySelectorAll("[data-variant-input]").forEach((input) => {
          input.checked = false;
        });

        firstInput.checked = true;

        requestAnimationFrame(() => {
          const variantId = firstInput.dataset.variantId;
          const variant = window.productVariants.find((v) => v.id === parseInt(variantId));

          updateVariantQtyDisplay(variant);

          firstInput.dispatchEvent(new Event("change", { bubbles: true }));
          firstInput.dispatchEvent(
            new CustomEvent("variant:change", {
              bubbles: true,
              detail: { variant: variant },
            }),
          );
        });
      }
    }

    // Event Listeners
    flavourDropdown.addEventListener("change", async (e) => {
      const selectedFlavour = e.target.value;

      // Step 1: Highlight active flavor immediately
      highlightActiveFlavour(selectedFlavour);
      updateDeliveryEstimation(selectedFlavour);

      if (activeGallery) {
        if (selectedFlavour) {
          await activeGallery.updateGallery(selectedFlavour);
        } else {
          await activeGallery.showAllContent();
        }
      }

      const checkedInput = document.querySelector(
        '[data-variant-input][data-variant-flavour="' + selectedFlavour + '"]:checked',
      );

      if (!checkedInput) {
        selectFirstSubvariantForFlavor(selectedFlavour);
      } else {
        if (activeGallery) {
          activeGallery.selectSlideByFlavor(selectedFlavour, checkedInput.value);
        }
      }

      if (window.metafieldsManager && window.metafieldsManager.isInitialized) {
        window.metafieldsManager.currentFlavor = selectedFlavour.toLowerCase();
        window.metafieldsManager.handleFlavorChange(selectedFlavour.toLowerCase());
      }

      // Ensure subscription options remain visible
      ensureSubscriptionOptionsVisible();

      if (
        activeGallery &&
        activeGallery.slideshow &&
        activeGallery.slideshow.offsetParent !== null
      ) {
        if (activeGallery.mainFlickity && typeof activeGallery.mainFlickity.resize === "function") {
          activeGallery.resize();
        }
      }
    });

    subvariantButtonsContainer.querySelectorAll("input[data-variant-input]").forEach((input) => {
      input.addEventListener("change", (e) => {
        const variantId = e.target.dataset.variantId;
        const variant = variants.find((v) => v.id === parseInt(variantId));
        if (variant) {
          const flavor = e.target.dataset.variantFlavour;
          const optionName = e.target.name;

          document
            .querySelectorAll(`input[name="${optionName}"][data-variant-flavour="${flavor}"]`)
            .forEach((input) => {
              input.checked = false;
            });

          e.target.checked = true;

          updateVariantQtyDisplay(variant);

          updateDeliveryEstimation(flavor);

          if (activeGallery && flavor) {
            activeGallery.selectSlideByFlavor(flavor, e.target.value);
          }

          // Ensure subscription options remain visible
          ensureSubscriptionOptionsVisible();

          const event = new CustomEvent("variant:change", {
            bubbles: true,
            detail: { variant: variant },
          });
          e.target.dispatchEvent(event);
        }
      });
    });

    window.addEventListener("resize", () => {
      if (activeGallery) {
        activeGallery.resize();
      }
    });

    window.addEventListener("orientationchange", () => {
      if (activeGallery) {
        setTimeout(() => {
          activeGallery.resize();
          this.thumbsFlickity.resize();
        }, 500);
      }
    });

    const defaultFlavour = flavourDropdown.value;
    if (defaultFlavour) {
      highlightActiveFlavour(defaultFlavour);

      updateDeliveryEstimation(defaultFlavour);

      setTimeout(() => {
        if (window.metafieldsManager && window.metafieldsManager.isInitialized) {
          window.metafieldsManager.currentFlavor = defaultFlavour.toLowerCase();
          window.metafieldsManager.handleFlavorChange(defaultFlavour.toLowerCase());
        }
      }, 100);

      const checkedInput = document.querySelector(
        '[data-variant-input][data-variant-flavour="' + defaultFlavour + '"]:checked',
      );

      if (checkedInput) {
        const variantId = checkedInput.dataset.variantId;
        const variant = variants.find((v) => v.id === parseInt(variantId));
        if (variant) {
          updateVariantQtyDisplay(variant);
          if (activeGallery) {
            activeGallery.selectSlideByFlavor(defaultFlavour, checkedInput.value);
          }
        }
      } else {
        const firstAvailableInput = document.querySelector(
          '[data-variant-input][data-variant-flavour="' +
            defaultFlavour +
            '"]:not(:disabled):not(.disabled)',
        );

        if (firstAvailableInput && activeGallery) {
          activeGallery.selectSlideByFlavor(defaultFlavour, firstAvailableInput.value);
        }
      }
    }

    setTimeout(() => {
      if (activeGallery) {
        const currentFlavor = flavourDropdown.value;
        if (currentFlavor) {
          // Find any checked input for this flavor
          const checkedInput = document.querySelector(
            '[data-variant-input][data-variant-flavour="' + currentFlavor + '"]:checked',
          );

          if (checkedInput) {
            // Select the slide for this flavor
            activeGallery.selectSlideByFlavor(currentFlavor, checkedInput.value);
          } else {
            // Find first available variant for this flavor
            const firstAvailableInput = document.querySelector(
              '[data-variant-input][data-variant-flavour="' +
                currentFlavor +
                '"]:not(:disabled):not(.disabled)',
            );

            if (firstAvailableInput) {
              // Select the first available slide for this flavor
              activeGallery.selectSlideByFlavor(currentFlavor, firstAvailableInput.value);
            }
          }
        }

        // Ensure gallery is properly sized
        activeGallery.resize();
      }
    }, 200);

    // Initialize delivery estimation on page load
    setTimeout(() => {
      const currentFlavor = flavourDropdown.value;
      if (currentFlavor) {
        console.log("Initializing delivery estimation with flavor:", currentFlavor);
        updateDeliveryEstimation(currentFlavor);
      } else {
        console.log("No current flavor found for initialization");
      }
    }, 300);

    // Also try to initialize after a longer delay in case the page is still loading
    setTimeout(() => {
      const currentFlavor = flavourDropdown.value;
      if (currentFlavor) {
        updateDeliveryEstimation(currentFlavor);
      }
    }, 1000);

    window.addEventListener("load", () => {
      setTimeout(() => {
        const currentFlavor = flavourDropdown.value;
        if (currentFlavor) {
          console.log(
            "Page load initialization of delivery estimation with flavor:",
            currentFlavor,
          );
          updateDeliveryEstimation(currentFlavor);
        }
      }, 500);
    });

    window.testDeliveryEstimation = function (flavor) {
      console.log("Testing delivery estimation update for flavor:", flavor);
      updateDeliveryEstimation(flavor);
    };

    // Helper function to update variant quantity display
    function updateVariantQtyDisplay(variant) {
      if (!variant) return;

      let selectedInput = document.querySelector(
        `input[data-variant-id="${variant.id}"][data-variant-input]:checked`,
      );

      // Fallback: if not found, get the first available input for this variant
      if (!selectedInput) {
        selectedInput = document.querySelector(
          `input[data-variant-id="${variant.id}"][data-variant-input]`,
        );
      }

      const qty = selectedInput
        ? parseInt(selectedInput.getAttribute("data-packaging-quantity"), 10) || 1
        : 1;

      const variantQtyValue = document.querySelector(".variant-qty__value");
      if (variantQtyValue) {
        const singular = variantQtyValue.dataset.singular || "";
        const plural = variantQtyValue.dataset.plular || "";

        if (qty === 1) {
          variantQtyValue.textContent = `1 ${singular}`;
        } else {
          variantQtyValue.textContent = `${qty} ${plural}`;
        }
      }
    }
  });

  // Function to ensure subscription options remain visible
  function ensureSubscriptionOptionsVisible() {
    // Find all subscription option elements
    const subscriptionOptions = document.querySelectorAll(".sealsubs-container .sls-select option");
    const subscriptionContainers = document.querySelectorAll(
      ".sealsubs-container .sls-option-container",
    );

    // Remove any hidden styles from options
    subscriptionOptions.forEach((option) => {
      if (option.style.display === "none") {
        option.style.display = "";
        option.removeAttribute("hidden");
      }
    });

    // Ensure subscription containers are visible (skip multipack-hidden groups)
    subscriptionContainers.forEach((container) => {
      if (container.classList.contains("mp-plan-hidden")) return;
      if (container.style.display === "none") {
        container.style.display = "";
        container.removeAttribute("hidden");
      }
    });

    // When multipack selector is active, force-enable Seal options that Seal
    // disabled due to variant mismatch (multipack always uses the base variant
    // but selling plans should still be available)
    if (document.querySelector("[data-multipack-selector]")) {
      const disabledContainers = document.querySelectorAll(
        ".sealsubs-container .sls-disabled-option-container:not(.mp-plan-hidden)",
      );
      disabledContainers.forEach((container) => {
        container.classList.remove("sls-disabled-option-container");
      });

      const disabledSelects = document.querySelectorAll(
        ".sealsubs-container select[disabled]",
      );
      disabledSelects.forEach((select) => {
        select.removeAttribute("disabled");
      });

      const disabledOptions = document.querySelectorAll(
        ".sealsubs-container option[disabled]",
      );
      disabledOptions.forEach((option) => {
        option.removeAttribute("disabled");
      });
    }

    // Force the subscription app to re-render if needed
    const sealsubsContainer = document.querySelector(".sealsubs-container");
    if (sealsubsContainer) {
      // Trigger a custom event to notify the subscription app
      const event = new CustomEvent("variant:changed", {
        detail: {
          action: "ensure_visibility",
          timestamp: Date.now(),
        },
      });
      sealsubsContainer.dispatchEvent(event);
    }
  }

  // Set up MutationObserver to automatically restore hidden subscription options
  function setupSubscriptionVisibilityObserver() {
    const sealsubsContainer = document.querySelector(".sealsubs-container");
    if (!sealsubsContainer) return;

    const observer = new MutationObserver((mutations) => {
      let needsRestore = false;

      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          (mutation.attributeName === "style" || mutation.attributeName === "hidden")
        ) {
          const target = mutation.target;
          if (
            target.classList.contains("sls-select") ||
            target.classList.contains("sls-option-container") ||
            target.closest(".sealsubs-container")
          ) {
            if (target.style.display === "none" || target.hasAttribute("hidden")) {
              needsRestore = true;
            }
          }
        }
      });

      if (needsRestore) {
        // Use a small delay to ensure the subscription app has finished its operations
        setTimeout(() => {
          ensureSubscriptionOptionsVisible();
        }, 100);
      }
    });

    observer.observe(sealsubsContainer, {
      attributes: true,
      attributeFilter: ["style", "hidden"],
      subtree: true,
    });

    return observer;
  }

  // Initialize the subscription visibility observer when the page loads
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(setupSubscriptionVisibilityObserver, 1000);
      setupPeriodicSubscriptionCheck();
    });
  } else {
    setTimeout(setupSubscriptionVisibilityObserver, 1000);
    setupPeriodicSubscriptionCheck();
  }

  // Set up periodic check for subscription options visibility
  function setupPeriodicSubscriptionCheck() {
    // Check every 2 seconds for hidden subscription options
    setInterval(() => {
      const sealsubsContainer = document.querySelector(".sealsubs-container");
      if (sealsubsContainer) {
        const hiddenOptions = sealsubsContainer.querySelectorAll(
          'option[style*="display: none"], option[hidden]',
        );
        const hiddenContainers = sealsubsContainer.querySelectorAll(
          '.sls-option-container[style*="display: none"]:not(.mp-plan-hidden), .sls-option-container[hidden]:not(.mp-plan-hidden)',
        );
        const disabledContainers = document.querySelector("[data-multipack-selector]")
          ? sealsubsContainer.querySelectorAll(".sls-disabled-option-container")
          : [];

        if (hiddenOptions.length > 0 || hiddenContainers.length > 0 || disabledContainers.length > 0) {
          ensureSubscriptionOptionsVisible();
        }
      }
    }, 2000);
  }

  // Handle flavor changes and variant availability
  document.addEventListener("change", async function (event) {
    const flavorDropdown = event.target.closest("[data-flavour-dropdown]");

    if (!flavorDropdown) return;

    const flavor = flavorDropdown.value;
    const variantButtons = document.querySelectorAll("[data-subvariant-buttons] .variant-input");

    if (!variantButtons.length) return;

    // Check if any variant is already selected for this flavor
    const checkedInput = document.querySelector(
      '[data-variant-input][data-variant-flavour="' + flavor + '"]:checked',
    );

    if (!checkedInput) {
      let firstAvailableVariant = null;
      let firstVariant = null;

      variantButtons.forEach((button) => {
        if (button.dataset.variantFlavour === flavor) {
          if (!firstVariant) firstVariant = button;
          const input = button.querySelector("input[data-variant-input]");
          if (input && !input.classList.contains("disabled")) {
            if (!firstAvailableVariant) firstAvailableVariant = input;
          }
        }
      });

      const variantToSelect = firstAvailableVariant || firstVariant;
      if (variantToSelect) {
        variantToSelect.checked = true;
        variantToSelect.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    // Update active flavor state
    variantButtons.forEach((button) => {
      button.classList.remove("is-active-flavour");
      if (button.dataset.variantFlavour === flavor) {
        button.classList.add("is-active-flavour");
      }
    });

    // Update delivery estimation and preorder shipping dates when flavor changes
    updateDeliveryEstimation(flavor);

    // Update metafields when flavor changes
    if (window.metafieldsManager && window.metafieldsManager.isInitialized) {
      window.metafieldsManager.currentFlavor = flavor.toLowerCase();
      window.metafieldsManager.handleFlavorChange(flavor.toLowerCase());
    }

    // Ensure subscription options remain visible
    ensureSubscriptionOptionsVisible();

    // Resize gallery after metafields update is complete
    await new Promise((resolve) => {
      if (
        activeGallery &&
        activeGallery.slideshow &&
        activeGallery.slideshow.offsetParent !== null
      ) {
        if (activeGallery.mainFlickity && typeof activeGallery.mainFlickity.resize === "function") {
          activeGallery.resize();
        }
      }
      resolve();
    });
  });

  function updateDeliveryEstimation(flavor) {
    const variantsMetafields = document.querySelector("[data-variants-metafields]");
    if (!variantsMetafields) return;

    // Find the FIRST variant of the selected flavor (Einzelpackung/500g) as source of truth
    let sourceVariantData = null;
    const allVariants = Array.from(variantsMetafields.querySelectorAll("[data-variant-id]"));

    // Find the first variant that matches the flavor (should be the Einzelpackung/500g variant)
    sourceVariantData = allVariants.find((variant) => {
      const variantId = variant.getAttribute("data-variant-id");
      // Check if this variant belongs to the selected flavor
      const flavorInput = document.querySelector(
        `[data-variant-input][data-variant-flavour="${flavor}"][data-variant-id="${variantId}"]`,
      );
      return flavorInput !== null;
    });

    // If no source variant found, fall back to the currently selected variant
    if (!sourceVariantData) {
      const checkedInputs = document.querySelectorAll(
        `[data-variant-input][data-variant-flavour="${flavor}"]:checked`,
      );

      if (checkedInputs.length > 0) {
        const checkedInput = checkedInputs[0];

        sourceVariantData = allVariants.find((variant) => {
          return variant.getAttribute("data-variant-id") === checkedInput.dataset.variantId;
        });
      } else {
        const anyInput = document.querySelector(
          `[data-variant-input][data-variant-flavour="${flavor}"]`,
        );
        if (anyInput) {
          sourceVariantData = allVariants.find((variant) => {
            return variant.getAttribute("data-variant-id") === anyInput.dataset.variantId;
          });
        }
      }
    }

    if (!sourceVariantData) return;

    const isAvailable = sourceVariantData.getAttribute("data-variant-available") === "true";
    const inventory = parseInt(sourceVariantData.getAttribute("data-variant-inventory") || "0", 10);
    const inventoryPolicy = sourceVariantData.getAttribute("data-variant-inventory-policy");
    const inventoryManagement = sourceVariantData.getAttribute("data-variant-inventory-management");

    let isOutOfStock = false;
    let canSellWhenOutOfStock = false;

    if (inventoryManagement === "shopify") {
      if (inventory <= 0) {
        if (inventoryPolicy === "continue") {
          isOutOfStock = false;
          canSellWhenOutOfStock = true;
        } else {
          isOutOfStock = true;
          canSellWhenOutOfStock = false;
        }
      } else {
        isOutOfStock = false;
        canSellWhenOutOfStock = false;
      }
    } else {
      isOutOfStock = !isAvailable;
      canSellWhenOutOfStock = false;
    }

    const deliveryEstimationDisplay = document.querySelector(
      ".product-block--sales-point--v2 [data-product-inventory]",
    );

    if (!deliveryEstimationDisplay) {
      return;
    }

    if (deliveryEstimationDisplay) {
      let deliveryText = "";

      if (isOutOfStock) {
        const outOfStockEstimation = sourceVariantData.getAttribute(
          "data-delivery-estimation-out-of-stock",
        );
        const shippingTimeOutOfStock = sourceVariantData.getAttribute(
          "data-shipping-time-out-of-stock",
        );

        if (outOfStockEstimation && outOfStockEstimation.trim() !== "") {
          // Replace |time| placeholder with actual shipping time
          if (shippingTimeOutOfStock && shippingTimeOutOfStock.trim() !== "") {
            deliveryText = outOfStockEstimation.replace(/\|time\|/g, shippingTimeOutOfStock);
          } else {
            deliveryText = outOfStockEstimation;
          }
        } else {
          const productIndicator = document.querySelector(
            ".product-block--sales-point--v2 [data-product-inventory]",
          );
          if (productIndicator && productIndicator.innerHTML.includes("out of stock")) {
            deliveryText = productIndicator.innerHTML;
          } else {
            deliveryText = "";
          }
        }

        const deliveryContainer = deliveryEstimationDisplay.closest(
          ".product-block--sales-point--v2",
        );
        if (deliveryContainer) {
          deliveryContainer.classList.add("inventory--low");
          deliveryContainer.classList.remove("preorder-mode");
        }
      } else if (canSellWhenOutOfStock) {
        const outOfStockEstimation = sourceVariantData.getAttribute(
          "data-delivery-estimation-out-of-stock",
        );
        const shippingTimeOutOfStock = sourceVariantData.getAttribute(
          "data-shipping-time-out-of-stock",
        );

        if (outOfStockEstimation && outOfStockEstimation.trim() !== "") {
          // Replace |time| placeholder with actual shipping time
          if (shippingTimeOutOfStock && shippingTimeOutOfStock.trim() !== "") {
            deliveryText = outOfStockEstimation.replace(/\|time\|/g, shippingTimeOutOfStock);
          } else {
            deliveryText = outOfStockEstimation;
          }
        } else {
          deliveryText =
            "Currently out of stock but available for preorder. Delivery estimation will be calculated at checkout.";
        }

        const deliveryContainer = deliveryEstimationDisplay.closest(
          ".product-block--sales-point--v2",
        );
        if (deliveryContainer) {
          deliveryContainer.classList.add("preorder-mode");
          deliveryContainer.classList.remove("inventory--low");
        }
      } else {
        const inStockEstimation = sourceVariantData.getAttribute("data-delivery-estimation");
        const shippingTimeInStock = sourceVariantData.getAttribute("data-shipping-time-in-stock");

        if (inStockEstimation && inStockEstimation.trim() !== "") {
          // Replace |time| placeholder with actual shipping time
          if (shippingTimeInStock && shippingTimeInStock.trim() !== "") {
            deliveryText = inStockEstimation.replace(/\|time\|/g, shippingTimeInStock);
          } else {
            deliveryText = inStockEstimation;
          }
        } else {
          const productIndicator = document.querySelector(
            ".product-block--sales-point--v2 [data-product-inventory]",
          );
          if (productIndicator) {
            deliveryText = productIndicator.innerHTML;
          }
        }

        const deliveryContainer = deliveryEstimationDisplay.closest(
          ".product-block--sales-point--v2",
        );
        if (deliveryContainer) {
          deliveryContainer.classList.remove("inventory--low");
          deliveryContainer.classList.remove("preorder-mode");
        }
      }

      if (deliveryText) {
        deliveryEstimationDisplay.innerHTML = deliveryText;
      }
    }

    // Update preorder shipping dates visibility
    const preorderShippingDates = document.querySelector("[data-preorder-shipping-dates]");
    if (preorderShippingDates) {
      if (isOutOfStock || canSellWhenOutOfStock) {
        const variantPreorderDates = sourceVariantData.getAttribute("data-preorder-shipping-dates");
        if (variantPreorderDates && variantPreorderDates.trim() !== "") {
          try {
            // Parse the metafield content - it should be HTML content
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = variantPreorderDates;

            // Extract text content and check if it contains dates
            const textContent = tempDiv.textContent || tempDiv.innerText || "";
            if (textContent.trim() !== "") {
              preorderShippingDates.style.display = "block";

              const hiddenInput = preorderShippingDates.querySelector('input[type="hidden"]');
              if (hiddenInput) {
                // Use the metafield content directly for the property value
                hiddenInput.value = textContent.trim();
              }
            } else {
              preorderShippingDates.style.display = "none";
              preorderShippingDates.querySelector('input[type="hidden"]').value = "";
            }
          } catch (error) {
            console.warn("Error parsing preorder shipping dates:", error);
            preorderShippingDates.style.display = "none";
            preorderShippingDates.querySelector('input[type="hidden"]').value = "";
          }
        } else {
          preorderShippingDates.style.display = "none";
          preorderShippingDates.querySelector('input[type="hidden"]').value = "";
        }
      } else {
        preorderShippingDates.style.display = "none";
        preorderShippingDates.querySelector('input[type="hidden"]').value = "";
      }
    }
  }

  (function () {
    let siteHeader = null;
    let dropdowns = null;
    let lastHeaderHeight = 0;
    let resizeTimeout = null;
    let observer = null;

    function adjustDropdownPositioning() {
      if (!siteHeader) {
        siteHeader = document.querySelector("#SiteHeader");
        if (!siteHeader) return;
      }

      const headerHeight = siteHeader.offsetHeight;

      if (headerHeight === lastHeaderHeight) return;

      lastHeaderHeight = headerHeight;

      if (!dropdowns) {
        dropdowns = document.querySelectorAll(".site-nav__dropdown.megamenu");
        if (!dropdowns.length) return;
      }

      requestAnimationFrame(() => {
        dropdowns.forEach((dropdown) => {
          if (headerHeight > 105) {
            dropdown.style.paddingTop = headerHeight + "px";
          } else {
            dropdown.style.top = "";
          }
        });
      });
    }

    function handleResize() {
      if (resizeTimeout) return;

      resizeTimeout = requestAnimationFrame(() => {
        adjustDropdownPositioning();
        resizeTimeout = null;
      });
    }

    function setupMutationObserver() {
      if (observer) {
        observer.disconnect();
      }

      observer = new MutationObserver((mutations) => {
        const hasRelevantChanges = mutations.some(
          (mutation) =>
            mutation.type === "attributes" &&
            mutation.attributeName === "class" &&
            (mutation.target.classList.contains("site-header--stuck") ||
              mutation.target.classList.contains("site-header--opening")),
        );

        if (hasRelevantChanges) {
          setTimeout(adjustDropdownPositioning, 10);
        }
      });

      if (siteHeader) {
        observer.observe(siteHeader, {
          attributes: true,
          attributeFilter: ["class"],
          subtree: false,
        });
      }
    }

    function initDropdownPositioning() {
      adjustDropdownPositioning();

      window.addEventListener("resize", handleResize, { passive: true });

      setupMutationObserver();
    }

    window.adjustDropdownPositioning = adjustDropdownPositioning;

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initDropdownPositioning);
    } else {
      initDropdownPositioning();
    }
  })();

  (function () {
    class MetafieldsManager {
      constructor() {
        this.variants = new Map();
        this.flavorMetafields = new Map();
        this.currentVariantId = null;
        this.currentFlavor = null;
        this.ingredientsTab = null;
        this.isInitialized = false;
        this.init();
      }

      init() {
        try {
          this.loadVariantsData();
          this.setupEventListeners();
          this.isInitialized = true;
        } catch (error) {
          // Silent error handling for production
        }
      }

      loadVariantsData() {
        const container = document.querySelector("[data-variants-metafields]");
        if (!container) return;

        const variantElements = container.querySelectorAll("[data-variant-id]");
        variantElements.forEach((element) => {
          const variantId = parseInt(element.getAttribute("data-variant-id"));
          const metafields = {
            title: element.getAttribute("data-tab-title"),
            table1: element.getAttribute("data-tab-table1"),
            table2: element.getAttribute("data-tab-table2"),
            content: element.getAttribute("data-tab-content"),
          };
          this.variants.set(variantId, metafields);
        });

        this.groupMetafieldsByFlavor();
      }

      groupMetafieldsByFlavor() {
        this.flavorMetafields.clear();

        const variants =
          window.productVariants ||
          JSON.parse(document.querySelector("[data-variant-json]")?.textContent || "[]");

        variants.forEach((variant) => {
          const flavor = variant.option2 || variant.option1;
          if (!flavor) return;

          const variantMetafields = this.variants.get(variant.id);
          if (!variantMetafields) return;

          const hasContent =
            variantMetafields.title ||
            variantMetafields.table1 ||
            variantMetafields.table2 ||
            variantMetafields.content;

          if (hasContent) {
            this.flavorMetafields.set(flavor.toLowerCase(), variantMetafields);
          }
        });
      }

      getCurrentVariantId() {
        if (window.currentVariant?.id) {
          return window.currentVariant.id;
        }

        const currentVariantJson = document.querySelector("[data-current-variant-json]");
        if (currentVariantJson) {
          try {
            const currentVariantData = JSON.parse(
              currentVariantJson.textContent || currentVariantJson.value,
            );
            if (currentVariantData?.id) {
              return currentVariantData.id;
            }
          } catch (error) {
            // Silent error handling for production
          }
        }

        const urlParams = new URLSearchParams(window.location.search);
        const variantParam = urlParams.get("variant");
        return variantParam ? parseInt(variantParam) : null;
      }

      getCurrentFlavor() {
        const variantId = this.getCurrentVariantId();
        if (!variantId) return null;

        const variants =
          window.productVariants ||
          JSON.parse(document.querySelector("[data-variant-json]")?.textContent || "[]");
        const currentVariant = variants.find((v) => v.id === variantId);

        if (!currentVariant) return null;

        return (currentVariant.option2 || currentVariant.option1)?.toLowerCase();
      }

      decodeHtmlContent(content) {
        if (!content) return "";
        try {
          return decodeURIComponent(content);
        } catch (error) {
          return content;
        }
      }

      updateIngredientsTab(metafields) {
        try {
          if (!metafields) {
            return;
          }

          this.ingredientsTab = document.querySelector(".ed-tab.ingredients");
          if (!this.ingredientsTab) {
            return;
          }

          const updates = [
            {
              selector: ".collapsible-trigger",
              content: metafields.title,
              field: "title",
            },
            {
              selector: ".tab_content#TabAction1",
              content: metafields.table1,
              field: "table1",
            },
            {
              selector: ".tab_content#TabAction2",
              content: metafields.table2,
              field: "table2",
            },
          ];

          updates.forEach(({ selector, content, field }) => {
            try {
              if (content) {
                const element = this.ingredientsTab.querySelector(selector);
                if (element) {
                  const decodedContent = this.decodeHtmlContent(content);
                  if (decodedContent !== element.innerHTML) {
                    element.innerHTML = decodedContent;
                  }
                }
              }
            } catch (error) {
              // Silent error handling for production
            }
          });

          this.updateContentArea(metafields.content);

          this.reinitializeTabSwitching();

          setTimeout(() => {
            this.rescaleCollapsibleHeight();
          }, 100);

          setTimeout(() => {
            const contentEl = this.ingredientsTab.querySelector(".collapsible-content__inner");
            if (contentEl) {
              const tabAction = contentEl.querySelector(".tab_action");
              if (tabAction) {
                const nextSibling = tabAction.nextElementSibling;
                if (!nextSibling) {
                  this.updateContentArea(metafields.content);
                }
              }
            }
          }, 200);
        } catch (error) {
          // Silent error handling for production
        }
      }

      reinitializeTabSwitching() {
        const tabNavElements = this.ingredientsTab.querySelectorAll(".tab_nav div");

        tabNavElements.forEach((el, index) => {
          const newEl = el.cloneNode(true);
          el.parentNode.replaceChild(newEl, el);
        });

        const newTabNavElements = this.ingredientsTab.querySelectorAll(".tab_nav div");

        newTabNavElements.forEach((el, index) => {
          el.addEventListener("click", (e) => {
            if (!e.currentTarget.classList.contains("active")) {
              const tabContents = this.ingredientsTab.querySelectorAll(".tab_content");
              tabContents.forEach((tabContent) => {
                tabContent.classList.toggle("hidden");
              });
              const tabNavs = this.ingredientsTab.querySelectorAll(".tab_nav div");
              tabNavs.forEach((tabNav) => {
                tabNav.classList.toggle("active");
              });
            }
          });
        });
      }

      updateContentArea(content) {
        if (!content) {
          return;
        }

        const contentEl = this.ingredientsTab.querySelector(".collapsible-content__inner");
        if (!contentEl) {
          return;
        }

        const tabAction = contentEl.querySelector(".tab_action");
        if (!tabAction) {
          return;
        }

        this.removeExistingContent(tabAction);

        const contentDiv = document.createElement("div");
        const decodedContent = this.decodeHtmlContent(content);
        contentDiv.innerHTML = decodedContent;

        tabAction.parentNode.insertBefore(contentDiv, tabAction.nextSibling);

        let nextSibling = tabAction.nextElementSibling;
        let siblingCount = 0;
        while (nextSibling) {
          nextSibling = nextSibling.nextElementSibling;
          siblingCount++;
        }

        setTimeout(() => {
          this.rescaleCollapsibleHeight();
        }, 50);
      }

      removeExistingContent(tabAction) {
        let nextSibling = tabAction.nextElementSibling;
        let removedCount = 0;

        while (nextSibling && !nextSibling.classList.contains("tab_action")) {
          const toRemove = nextSibling;
          nextSibling = nextSibling.nextElementSibling;
          toRemove.remove();
          removedCount++;
        }
      }

      rescaleCollapsibleHeight() {
        try {
          const collapsibleContent = this.ingredientsTab.querySelector(".collapsible-content");
          if (!collapsibleContent) return;

          const collapsibleInner = collapsibleContent.querySelector(".collapsible-content__inner");
          if (!collapsibleInner) return;

          const isOpen = collapsibleContent.classList.contains("is-open");
          if (!isOpen) return;

          const newHeight = collapsibleInner.offsetHeight;
          const isAutoHeight = collapsibleContent.classList.contains("collapsible--auto-height");

          collapsibleContent.classList.remove("hide");

          if (
            window.theme &&
            window.theme.utils &&
            typeof window.theme.utils.prepareTransition === "function"
          ) {
            window.theme.utils.prepareTransition(collapsibleContent, () => {
              collapsibleContent.style.height = newHeight + "px";
            });
          } else {
            collapsibleContent.style.transition =
              "height 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
            collapsibleContent.style.height = newHeight + "px";
          }

          if (isAutoHeight) {
            setTimeout(() => {
              collapsibleContent.style.height = "auto";
            }, 500);
          }
        } catch (error) {}
      }

      handleFlavorChange(flavor) {
        try {
          if (this.variants.size === 0) {
            this.loadVariantsData();
          }

          const metafields = this.flavorMetafields.get(flavor);

          if (metafields) {
            setTimeout(() => {
              this.updateIngredientsTab(metafields);
            }, 50);

            setTimeout(() => {
              this.updateIngredientsTab(metafields);
            }, 500);
          } else {
            this.handleNoMetafields();
          }
        } catch (error) {}
      }

      handleNoMetafields() {
        const ingredientsTab = document.querySelector(".ed-tab.ingredients");
        if (ingredientsTab) {
          // Keep existing content if no metafields found
        }
      }

      setupEventListeners() {
        this.setupTabSwitching();

        const handleInitialLoad = () => {
          try {
            setTimeout(() => {
              try {
                const currentFlavor = this.getCurrentFlavor();
                if (currentFlavor) {
                  this.currentFlavor = currentFlavor;
                  this.handleFlavorChange(currentFlavor);
                }
              } catch (error) {}
            }, 200);
          } catch (error) {}
        };

        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", handleInitialLoad, { passive: true });
        } else {
          handleInitialLoad();
        }
      }

      setupTabSwitching() {
        document.addEventListener(
          "click",
          (event) => {
            const tabNav = event.target.closest(".tab_nav div");
            if (tabNav && tabNav.closest(".ed-tab.ingredients")) {
              setTimeout(() => {
                this.rescaleCollapsibleHeight();
              }, 50);
            }
          },
          { passive: true },
        );
      }

      updateCurrentVariantJson(variant) {
        const currentVariantJson = document.querySelector("[data-current-variant-json]");
        if (currentVariantJson) {
          currentVariantJson.textContent = JSON.stringify(variant);
        }
      }

      destroy() {
        this.variants.clear();
        this.flavorMetafields.clear();
        this.isInitialized = false;
      }
    }

    const initializeMetafieldsManager = () => {
      try {
        if (window.metafieldsManager && window.metafieldsManager.isInitialized) {
          return;
        }

        if (!document.querySelector('[data-section-type="product"]')) {
          return;
        }

        window.metafieldsManager = new MetafieldsManager();
      } catch (error) {
        // Silent error handling for production
      }
    };

     if (document.readyState === "loading") {
       document.addEventListener("DOMContentLoaded", initializeMetafieldsManager, { passive: true });
     } else {
       setTimeout(initializeMetafieldsManager, 50);
     }
   })();

   // Modal handling for open-modal and close-modal attributes
   (function() {
     // Handle comparison modal button
     document.addEventListener('click', function(e) {
       const comparisonBtn = e.target.closest('[data-open-comparison-modal]');
       if (comparisonBtn) {
         e.stopPropagation();
         const comparisonModal = document.querySelector('.modal--comparison');
         if (comparisonModal) {
           comparisonModal.classList.add('modal-open');
           document.body.style.overflow = 'hidden';
         }
       }
     }, true); // Use capture phase

     // Handle open-modal buttons
     document.addEventListener('click', function(e) {
       const openButton = e.target.closest('[open-modal]');
       if (openButton) {
         e.stopPropagation();
         const modalId = openButton.getAttribute('href') || openButton.getAttribute('open-modal');
         if (modalId) {
           const modal = document.querySelector(modalId);
           if (modal) {
             modal.classList.add('modal-open');
             document.body.style.overflow = 'hidden';
           }
         }
       }

       // Handle close-modal buttons
       const closeButton = e.target.closest('[close-modal]');
       if (closeButton) {
         e.stopPropagation();
         const modalId = closeButton.getAttribute('data-close') || closeButton.getAttribute('close-modal');
         if (modalId) {
           const modal = document.querySelector(modalId);
           if (modal) {
             modal.classList.remove('modal-open');
             document.body.style.overflow = '';
           }
         }
       }
     });

     // Close modal when clicking outside (but not on selects/inputs)
     document.addEventListener('click', function(e) {
       if (e.target.classList.contains('modal') && e.target.classList.contains('modal-open')) {
         if (!e.target.querySelector('.modal__inner').contains(e.target)) {
           e.target.classList.remove('modal-open');
           document.body.style.overflow = '';
         }
       }
     });

     // Close modal on Escape key
     document.addEventListener('keydown', function(e) {
       if (e.key === 'Escape') {
         const openModals = document.querySelectorAll('.modal.modal-open');
         openModals.forEach(modal => {
           modal.classList.remove('modal-open');
           document.body.style.overflow = '';
         });
       }
     });
   })();
 })();
